import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { ITaskPriorityListItem, TaskPriorityListItem } from "./taskPriorityListItem";

export interface ITaskPriorityListItems extends ListItems<ITaskPriorityListItem> {
}

export class TaskPriorityListItems extends ListItems<TaskPriorityListItem> implements ITaskPriorityListItems {
    constructor();
    constructor(obj: ITaskPriorityListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, TaskPriorityListItem);
    }
}